interface PlaceholderSectionProps {
  message: string;
}

export function PlaceholderSection({ message }: PlaceholderSectionProps) {
  return (
    <div className="flex items-center justify-center py-8 opacity-40">
      <span className="text-primary text-sm">{message}</span>
    </div>
  );
}
